export const formatDate = (date: Date | number) => {
	return new Intl.DateTimeFormat("en-US", { dateStyle: "medium" }).format(date);
};

export const formatMoney = (amount: number, currency: string) =>
	new Intl.NumberFormat("en-US", {
		style: "currency",
		currency,
	}).format(amount);

// Catalog prices are integer cents (new catalog.json contract).
export const formatCents = (cents: number, currency = "USD") => formatMoney(cents / 100, currency);

// Render a catalog price_range: "From $45", "$45 – $600", or a fallback when unpriced.
// `maxCents` optionally clamps the top of the range — used to hide the price of unfulfillable
// sizes (24×36) from the shop grid so we don't advertise a size we can't yet make (TODO §E.6).
export const formatPriceRange = (
	range: { from_cents: number | null; to_cents: number | null },
	fallback = "Coming soon",
	maxCents?: number,
) => {
	const { from_cents } = range;
	let { to_cents } = range;
	if (from_cents === null) return fallback;
	if (to_cents != null && maxCents != null) to_cents = Math.min(to_cents, maxCents);
	if (to_cents === null || to_cents <= from_cents) return `From ${formatCents(from_cents)}`;
	return `${formatCents(from_cents)} – ${formatCents(to_cents)}`;
};

export const formatMoneyRange = (
	range: {
		start?: { amount: number; currency: string } | null;
		stop?: { amount: number; currency: string } | null;
	} | null,
) => {
	const { start, stop } = range || {};
	const startMoney = start && formatMoney(start.amount, start.currency);
	const stopMoney = stop && formatMoney(stop.amount, stop.currency);

	if (startMoney === stopMoney) {
		return startMoney;
	}

	return `${startMoney} - ${stopMoney}`;
};

export function getHrefForVariant({
	productSlug,
	variantId,
}: {
	productSlug: string;
	variantId?: string;
}): string {
	const pathname = `/products/${encodeURIComponent(productSlug)}`;

	if (!variantId) {
		return pathname;
	}

	const query = new URLSearchParams({ variant: variantId });
	return `${pathname}?${query.toString()}`;
}
